var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompilationManifestationBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4.938 11 C 4.981 10.52 5.216 9.893 5.523 9.586 C 5.83 9.279 6.457 9.044 6.938 9 L 20.147 9 C 20.585 9.035 21.171 9.267 21.514 9.541 L 24.361 12.209 C 24.758 12.63 25.15 12.785 25.728 12.75 L 42.937 12.75 C 43.418 12.794 44.045 13.029 44.352 13.336 C 44.659 13.643 44.894 14.27 44.937 14.75 L 44.937 37 C 44.894 37.48 44.659 38.107 44.352 38.414 C 44.045 38.721 43.418 38.956 42.937 39 L 6.937 39 C 6.457 38.956 5.83 38.721 5.523 38.414 C 5.216 38.107 4.981 37.48 4.937 37 L 4.938 11 Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompilationManifestationBlack);
export default __webpack_public_path__ + "static/media/compilation_manifestation_black.cac25fbeb14996b175f403ee703312e5.svg";
export { ForwardRef as ReactComponent };